<template>
  <div class="bb-contact-projects" ref="bbContactProjects">
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
    <div class="bb-contact-projects-header">
      <button class="bb-button bb-contact-projects-header__button" @click="goToClientProjects">
        {{clientInfo.nickName}} ALL PROJECTS
      </button>
    </div>
    <VuePerfectScrollbar class="bb-contact-projects-table"
                         ref="bbContactCurrentProjectsTable"
                         :style="{
                           height: tableHeightProjects.bbContactCurrentProjectsTable
                         }">
      <Table :options="optionsTable"
             :hide-scroll="true"
             :modal-mode="true"
             :min-width="1050"/>
    </VuePerfectScrollbar>
    <div class="bb-contact-projects-info"
         v-if="contactsProjectsRowsDataApproved.length > 0"
         @click="showCompleted = !showCompleted">
      +{{contactsProjectsRowsDataApproved.length}} COMPLETED PROJECTS
      <div class="bb-contact-projects-info__wrapper-popup">
        <i class="icon-info bb-contact-projects-info__totals"
           @mouseenter="showTotal = true"
           @mouseleave="showTotal = false"/>
        <transition name="bounce">
          <div class="bb-table-header-popup bb-contact-projects-info__popup" v-if="showTotal">
            <span class="bb-table-header-popup__title">
              BB Services
            </span>
            {{convertNumber(totalBBServices)}}
        </div>
      </transition>
      </div>
    </div>
    <VuePerfectScrollbar class="bb-contact-projects-table"
                         ref="bbContactCompletedProjectsTable"
                         :class="{'bb-contact-projects-table_hide': !showCompleted}"
                         :style="{
                           height: tableHeightProjects.bbContactCompletedProjectsTable
                         }">
      <Table :options="optionsTableApproved"
             :hide-scroll="true"
             :modal-mode="true"
             :min-width="1050"/>
    </VuePerfectScrollbar>
    <transition name="fade" mode="out-in">
      <ModalWindow @close="proformaOpen = false" v-if="proformaOpen">
        <ProformaInvoice @close="proformaOpen = false"
                         :view-mode="true"
                         :editable-invoice="editableInvoice"/>
      </ModalWindow>
    </transition>
    <transition name="fade" mode="out-in">
      <ModalWindow @close="openSetManager = false"
                   v-if="openSetManager"
                   :title="managerModalTitle"
                   :without-padding="true">
        <SetManager :type="managerModalType"
                    :project="editableManagerProject"
                    @save="updateManager"
                    @close="openSetManager = false"/>
      </ModalWindow>
    </transition>
  </div>
</template>

<script>
import {
  contactProjectsTable,
  contactProjectsTableApproved,
  contactProjectsTableColumns,
  contactProjectsTableColumnsApproved
} from '@/constants/TablesOptions/contactsProjectsTable'
import {filter, get, find, set, orderBy} from 'lodash'
import Table from '@/components/Main/Table/Table'
import ContactsApi from '@/api/Contacts/api'
import setKpiServices from '@/mixin/setKpiServices'
import alertIcon from '@/assets/images/alert.png'
import InvoiceApi from '@/api/Invoce/api'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import ModalWindow from '@/components/Main/ModalWindow/ModalWindow'
import ProformaInvoice from '@/components/Dissemination/Sales/CRM/ContactCard/ProformaInvoice/ProformaInvoice'
import SetManager from './SetManager/SetManager'

export default {
  name: 'ContactProjects',
  components: {
    SetManager,
    Table,
    VuePerfectScrollbar,
    LoaderFly,
    ModalWindow,
    ProformaInvoice
  },
  mixins: [setKpiServices],
  data () {
    return {
      editableInvoice: {
        invoice: {}
      },
      proformaOpen: false,
      loaderRun: false,
      totalBBServices: 0,
      bodyProjectsWidth: 'auto',
      tableHeightProjects: {
        bbContactCompletedProjectsTable: 'auto',
        bbContactCurrentProjectsTable: 'auto'
      },
      showTotal: false,
      showCompleted: false,
      optionsTable: contactProjectsTable,
      optionsTableApproved: contactProjectsTableApproved,
      noItems: false,
      openSetManager: false,
      managerModalType: 0,
      managerModalTitle: '',
      editableManagerProject: {}
    }
  },
  computed: {
    contactsProjectsColumnsData: {
      get: function () {
        return this.$store.getters.contactsProjectsColumnsData
      },
      set: function (data) {
        this.$store.dispatch('setContactsProjectsColumnsData', data)
      }
    },
    contactsProjectsColumnsDataApproved: {
      get: function () {
        return this.$store.getters.contactsProjectsColumnsDataApproved
      },
      set: function (data) {
        this.$store.dispatch('setContactsProjectsColumnsDataApproved', data)
      }
    },
    contactsProjectsRowsData: {
      get: function () {
        return this.$store.getters.contactsProjectsRowsData
      },
      set: function (data) {
        this.$store.dispatch('setContactsProjectsRowsData', data)
      }
    },
    contactsProjectsRowsDataApproved: {
      get: function () {
        return this.$store.getters.contactsProjectsRowsDataApproved
      },
      set: function (data) {
        this.$store.dispatch('setContactsProjectsRowsDataApproved', data)
      }
    },
    clientInfo () {
      return this.$store.getters.clientInfo
    }
  },
  methods: {
    goToClientProjects () {
      this.$router.push({
        name: 'ListOfProjectByClient',
        params: {clientId: this.clientInfo.id}
      })
    },
    addActions () {
      this.contactsProjectsColumnsData.forEach(item => {
        if (item.actions) {
          item.actions.edit = this.updateServiceDates
        }
        if (item.hover && item.property === 'number') {
          item.clickAction = this.openProforma
        }
        if (item.action === 'setManager') {
          item.clickAction = this.setManagerModal
        }
      })
    },
    async getInvoice (id) {
      try {
        const resp = await InvoiceApi.getInvoiceById(id)
        return resp.data
      } catch (e) {
        console.error(e)
        return {}
      }
    },
    getRequiredFields (invoice) {
      const invoiceId = get(invoice, 'id', '')
      const uploadFilesIds = get(invoice, 'uploadFile', []).map(file => file.id)
      const ibanList = get(invoice, 'ibanList', [])
      return {
        id: invoiceId,
        uploadFile: uploadFilesIds,
        ibanList: ibanList
      }
    },
    setManagerModal (row, column) {
      const hasManager = get(row, 'projectManager._id', '')
      const hasConsultant = get(row, 'businessConsultant._id', '')
      if (column.$type === 'pm' && hasManager) return
      if (column.$type === 'bc' && hasConsultant) return
      this.openSetManager = true
      this.managerModalType = column.$type
      this.editableManagerProject = row
      this.managerModalTitle = column.$type === 'pm' ? 'Select Project Manager' : 'Select Business Consultant'
    },
    closeManagerModal () {
      this.openSetManager = false
      this.managerModalType = 0
      this.editableManagerProject = {}
      this.managerModalTitle = ''
    },
    openProforma (row) {
      const id = get(row, 'invoiceId', false)
      if (!id) return
      this.loaderRun = true
      InvoiceApi.getInvoiceById(id)
        .then(resp => {
          this.editableInvoice = {
            invoice: resp.data
          }
          this.proformaOpen = true
          this.loaderRun = false
        })
        .catch(err => {
          console.error(err)
          this.loaderRun = false
        })
    },
    setServiceDates ({services, targetServiceId, started, deadline, percentProject, projectManager}) {
      const service = find(services, {id: targetServiceId})
      if (!services) return
      service.started = started
      service.deadline = deadline
      service.percentProject = percentProject
      const projectManagerID = get(projectManager, 'id', '')
      if (projectManagerID) service.projectManager = projectManagerID
      return services
    },
    async updateServiceDates (project) {
      if (project.isProject) {
        await this.editProject(project)
        return
      }
      const invoice = await this.getInvoice(project.invoiceId)
      const invoiceForUpdate = this.getRequiredFields(invoice)
      const paramsForSetDates = {
        services: invoice.services,
        targetServiceId: project._id,
        started: project.started,
        deadline: project.deadline,
        percentProject: project.percentProject
      }
      const projectManager = get(project, 'projectManager', '')
      if (projectManager) paramsForSetDates.projectManager = projectManager
      const consultantId = get(project, 'businessConsultant.id', '')
      if (consultantId) invoiceForUpdate.businessConsultant = consultantId
      invoiceForUpdate.services = this.setServiceDates(paramsForSetDates)
      this.updateInvoice(invoiceForUpdate, project)
    },
    async editProject (project) {
      const query = {
        id: project.id,
        userProformaNumber: project.number,
        dateStart: project.started,
        dateEnd: project.deadline,
        percentProject: project.percentProject
      }
      try {
        await ContactsApi.editProject(query)
        this.getProjects()
      } catch (e) {
        console.error(e)
      }
    },
    updateManager ({type, user}) {
      if (type === 'pm') {
        set(this.editableManagerProject, 'projectManager', user)
      } else if (type === 'bc') {
        set(this.editableManagerProject, 'businessConsultant', user)
      }
      this.updateServiceDates(this.editableManagerProject)
      this.closeManagerModal()
    },
    updateProject (project) {
      const currentProject = find(this.contactsProjectsRowsData, {id: project.id})
      if (!currentProject) return
      currentProject.started = project.started
      currentProject.deadline = project.deadline
      currentProject.percentProject = project.percentProject
      const consultantImage = get(currentProject, 'businessConsultant.image.path', '')
      if (consultantImage) set(currentProject, 'businessConsultant.image', consultantImage)
      const managerImage = get(currentProject, 'projectManager.image.path', '')
      if (managerImage) set(currentProject, 'projectManager.image', managerImage)
    },
    updateInvoice (invoice, project) {
      this.updateProject(project)
      InvoiceApi.editInvoices(invoice, invoice.id)
        .then(() => {})
        .catch((err) => {
          console.error(err)
        })
    },
    setServices (services, completed) {
      return services.map(service => {
        const datePM = service.approvedDate
        const dateBC = service.approvedDateBusinessConsultant
        service.completedDate = service.isBonus ? dateBC : datePM
        if (completed) {
          const checkmark = '<i class="icon-check-circle bb-contact-projects__checkmark"></i>'
          service.name = checkmark + service.name
        }
        service.coast = this.serviceAmount(service)
        const idBC = get(service, 'businessConsultant._id', '')
        if (!idBC) {
          set(service.businessConsultant, 'image.path', alertIcon)
        }
        const idPM = get(service, 'projectManager._id', '')
        if (!idPM) {
          set(service.projectManager, 'image.path', alertIcon)
        }
        return service
      })
    },
    getFilterServices (services, getCompleted) {
      return filter(services, service => {
        const completed = service.isCompleted
        return getCompleted ? completed : !completed
      })
    },
    getProjects () {
      const params = {
        clientId: this.clientInfo.id
      }
      if (!params.clientId) return
      this.loaderRun = true
      this.totalBBServices = 0
      this.contactsProjectsRowsData = []
      ContactsApi.getProjects(params)
        .then(resp => {
          this.totalBBServices = resp.data.totalProjects
          const services = orderBy(resp.data.clientProjects, ['paymentDate'], ['desc'])
          const unfinishedServices = this.getFilterServices(services, false)
          this.contactsProjectsRowsData = this.setServices(unfinishedServices, false)
          const completedServices = this.getFilterServices(services, true)
          this.contactsProjectsRowsDataApproved = this.setServices(completedServices, true)
          this.$nextTick(this.calcHeightTables)
          this.loaderRun = false
        })
        .catch(e => {
          this.loaderRun = false
          console.error(e)
        })
    },
    calcWidthTable () {
      const bodyProjects = this.$refs.bbContactProjects
      if (!bodyProjects) return
      this.bodyProjectsWidth = `${bodyProjects.offsetWidth}px`
    },
    calcHeightTables () {
      const tables = ['bbContactCompletedProjectsTable', 'bbContactCurrentProjectsTable']
      tables.forEach(refName => {
        const table = get(this.$refs, [refName, '$el'], '')
        if (!table) return
        set(this.tableHeightProjects, refName, `${table.scrollHeight}px`)
      })
    },
    calcTable () {
      this.calcHeightTables()
    }
  },
  mounted () {
    window.addEventListener('resize', this.calcTable, false)
  },
  beforeMount () {
    this.getProjects()
    this.contactsProjectsColumnsData = contactProjectsTableColumns
    this.contactsProjectsColumnsDataApproved = contactProjectsTableColumnsApproved
    this.addActions()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.calcTable, false)
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../sass/variables";
  @import "../../../../../../sass/mixins";

  .bb-contact-projects {
    display: grid;
    flex-direction: column;
    padding: 0 25px;

    &-header {
      &__button {
        margin-left: auto;
        padding: 13px 14px;
        margin-bottom: 10px;
      }
    }

    &-info {
      display: flex;
      align-items: center;
      margin: 27px auto 10px 0;
      padding: 10px 15px;
      border: 1.5px solid $color-accent;
      box-sizing: border-box;
      border-radius: 5px;
      font-weight: 600;
      font-size: 13px;
      color: $color-accent;
      cursor: pointer;
      white-space: nowrap;

      &:hover {
        color: $color-accent-hover;
        border-color: $color-accent-hover;
      }

      &__wrapper-popup {
        position: relative;
      }

      &__totals {
        color: $color-silver-chalice;
        margin-left: 13px;
        cursor: pointer;
      }

      &__popup {
        position: absolute;
        white-space: nowrap;
        bottom: 22px;
        left: 8px;
      }
    }

    &-table {
      position: relative;
      overflow: hidden;
      padding: 0 10px;
      margin: 10px -10px 0;
      transition: 0.5s;
      opacity: 1;
      box-shadow: 0 0 20px rgba($color-black, 0.05);

      &_hide {
        opacity: 0;
        max-height: 0;
      }
    }
  }
</style>

<style lang="scss">
  @import "../../../../../../sass/variables";

  .bb-contact-projects {
    &__checkmark {
      margin-right: 5px;
      font-size: 16px;
      color: $color-japanese-laurel;
    }

    .ps__rail-x, .ps_thumb-x,
    .ps__rail-y, .ps__thumb-y {
      z-index: 9;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactProjects/ContactProjects.vue